<template>
  <header class="header-wrapper">
    <div class="header-contents">
      
      <router-link tag="div"
        class="header-col pointer-element"
        :to="{name:'welcome'}">
        <img class="bt-logo" src="/static/android-chrome-192x192.png">
        <span class="bt-title">BiblioTrees</span>
      </router-link>

      <div class="header-col">
        <div class="home">
          <v-btn small depressed>
            <router-link tag="div"
              class="small text"
              :to="{name:'welcome'}">
              <v-icon small>mdi-chevron-left</v-icon>
                {{ $t('register.home') }}
            </router-link>
          </v-btn>
        </div>

        <router-link v-if="!user_name && route_name!='login'"
          :to="{name: 'login'}"
          tag="div"
          class="link-element pointer-element firstname">
          {{ $t('register.login') }}
        </router-link>

        <router-link v-if="!!user_name"
          :to="{name: 'lab'}"
          tag="div"
          class="link-text link-element firstname">
          Hello, {{ user_name }}
        </router-link>
      </div>

    </div>
  </header>
</template>

<script>
export default {

  data() {
    return {
      firstname: null,
      username: null,
    }
  },

  computed: {
    route_name() {
      return this.$route.name
    },

    route_full_path() {
      return this.$route.fullPath
    },

    user_name() {
      return !!this.firstname ? this.firstname : this.username
    }
  },

  watch: {
    route_full_path: {
      async handler(val) {
        let access_token = this.$store.getters['auth/access_token']
        if (!!access_token) {
          try {
            await this.$store.dispatch('user/getUserInfo')
          } finally {
            this.firstname = this.$store.getters['user/firstname']
            this.username = this.$store.getters['user/username']
          }
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
  .header-wrapper {
    position: fixed;
    z-index: 1000;
    top: 0;
    height: 70px;
    width: 100%;
    padding: 0 40px;
    background-color: rgba(255,255,255,0.95);
  }

  .header-contents {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    max-width: 1280px;
    width: 100%;
    height: 100%;
    margin: auto;
  }

  .header-col {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;
  }

  .header-col > div {
    margin-left: 20px;
  }

  .bt-logo {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    transform: translateY(1.5px);
  }

  .bt-title{
    font-family: "Bree Serif", serif;
    font-size: 16pt;
  }

  .firstname {
    margin-left: 30px;
    font-size: 14px;
    font-family: "Montserrat", sans-serif !important;
    min-width: 50px;
  }

  @media only screen and (max-width: 550px) {
    .bt-title, .home {
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shared_components/part/HeaderSimple.vue